import { GridRequest } from 'projects/app-core/src/models/gridRequest';

export interface TherapistFeedbackGridRequest
  extends GridRequest<
    TherapistFeedbackSort,
    TherapistFeedbackFilter,
    TherapistFeedbackSearch,
    TherapistFeedbackDateFilter
  > {}

export enum TherapistFeedbackSort {
  RATING = 'RATING',
  CREATED_AT = 'CREATED_AT',
}
export enum TherapistFeedbackSearch {
  NAME = 'NAME',
  PARTNER = 'PARTNER',
}

export enum TherapistFeedbackDateFilter {
  START_DATE = 'START_DATE',
}

export enum TherapistFeedbackFilter {
  PLAN_ID = 'PLAN_ID',
  VERTICAL_ID = 'VERTICAL_ID',
  CONCERN_ID = 'CONCERN_ID',
  TEST = 'TEST',
  THERAPIST_ID = 'THERAPIST_ID',
}
